import { useEffect, useState } from 'react';

const useNotification = (items) => {
  const [notification, setNotification] = useState('');

  useEffect(() => {
    const newNotification =
      items.length === 1
        ? 'Shareable video link has been copied to clipboard.'
        : 'List of shareable video links has been copied to clipboard.';

    setNotification(newNotification);
  }, [items]);

  return notification;
};

export default useNotification;
